import { ComponentPropsWithRef } from 'react';

export enum Variant {
  Primary = 'primary',
  PrimaryWordWrap = 'primaryWordWrap',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Text = 'text',
}

export enum CaretPosition {
  Left = 'Left',
  Right = 'Right',
}

export interface ButtonProps extends ComponentPropsWithRef<'button'> {
  label: string;
  variant?: Variant;
  isSmall?: boolean;
  caret?: CaretPosition;
  isLoading?: boolean;
  loadingLabel?: string;
  testId?: string;
}

export type StyledProps = {
  isSmall?: boolean;
  isLoading?: boolean;
  caret?: CaretPosition;
};
